// http://gcctech.org/csc/javascript/javascript_keycodes.htm
export enum KeyCodes {
  TAB = 9,
  ENTER = 13,
  SPACE = 32
}
